var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDatasets = function SvgDatasets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51,
    height: 56,
    fill: "none",
    viewBox: "0 0 51 56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#datasets_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M14.238 11.714v5.743c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748c.856.436 1.976.436 4.216.436h5.029"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#datasets_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M14.238 40.286v-5.743c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.856-.436 1.976-.436 4.216-.436h5.029"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#datasets_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M37.095 11.714v5.743c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.855.436-1.976.436-4.216.436h-5.028"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#datasets_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M37.095 40.286v-5.743c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748c-.855-.436-1.976-.436-4.216-.436h-5.028"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 26.562,
    height: 26.562,
    x: 23.814,
    y: 0.325
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#datasets_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#datasets_svg__f)",
    shapeRendering: "crispEdges"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets_svg__g)",
    fillOpacity: 0.2,
    d: "M31.381 11.714c0-1.596 0-2.394.225-3.035a4 4 0 0 1 2.454-2.455C34.702 6 35.5 6 37.095 6s2.394 0 3.036.224a4 4 0 0 1 2.454 2.455c.225.641.225 1.44.225 3.035s0 2.394-.225 3.036a4 4 0 0 1-2.454 2.454c-.642.225-1.44.225-3.036.225s-2.393 0-3.035-.225a4 4 0 0 1-2.454-2.454c-.225-.642-.225-1.44-.225-3.036"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets_svg__h)",
    d: "M31.381 11.714c0-1.596 0-2.394.225-3.035a4 4 0 0 1 2.454-2.455C34.702 6 35.5 6 37.095 6s2.394 0 3.036.224a4 4 0 0 1 2.454 2.455c.225.641.225 1.44.225 3.035s0 2.394-.225 3.036a4 4 0 0 1-2.454 2.454c-.642.225-1.44.225-3.036.225s-2.393 0-3.035-.225a4 4 0 0 1-2.454-2.454c-.225-.642-.225-1.44-.225-3.036",
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    strokeWidth: 0.714,
    d: "M37.095 6.357c1.626 0 2.348.005 2.918.205a3.64 3.64 0 0 1 2.235 2.235c.2.57.204 1.291.204 2.917s-.004 2.348-.204 2.918a3.64 3.64 0 0 1-2.235 2.235c-.57.2-1.292.204-2.918.204s-2.347-.005-2.917-.204a3.64 3.64 0 0 1-2.235-2.235c-.2-.57-.205-1.292-.205-2.918s.005-2.347.205-2.917a3.64 3.64 0 0 1 2.235-2.235c.57-.2 1.291-.205 2.917-.205Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 26.562,
    height: 26.562,
    x: 12.385,
    y: 14.61
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#datasets_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#datasets_svg__j)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets_svg__k)",
    d: "M19.952 26c0-1.596 0-2.394.225-3.035a4 4 0 0 1 2.454-2.455c.642-.224 1.44-.224 3.036-.224s2.394 0 3.035.224a4 4 0 0 1 2.454 2.454c.225.642.225 1.44.225 3.036s0 2.394-.224 3.035a4 4 0 0 1-2.455 2.455c-.641.224-1.44.224-3.035.224s-2.394 0-3.036-.224a4 4 0 0 1-2.454-2.455c-.225-.641-.225-1.44-.225-3.035"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 0.268,
    d: "M25.666 20.42c1.607 0 2.377.001 2.991.216a3.87 3.87 0 0 1 2.374 2.372c.215.615.216 1.385.216 2.992s-.002 2.376-.216 2.99a3.87 3.87 0 0 1-2.373 2.374c-.615.215-1.385.217-2.992.217s-2.376-.002-2.991-.217a3.87 3.87 0 0 1-2.372-2.373c-.215-.615-.217-1.385-.217-2.991s.002-2.377.217-2.992a3.87 3.87 0 0 1 2.372-2.372c.615-.215 1.384-.217 2.991-.217Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 26.562,
    height: 26.562,
    x: 23.814,
    y: 28.896
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#datasets_svg__l)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#datasets_svg__m)",
    shapeRendering: "crispEdges"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets_svg__n)",
    fillOpacity: 0.5,
    d: "M31.381 40.286c0-1.596 0-2.394.225-3.036a4 4 0 0 1 2.454-2.454c.642-.224 1.44-.224 3.035-.224s2.394 0 3.036.224a4 4 0 0 1 2.454 2.454c.225.642.225 1.44.225 3.036s0 2.394-.225 3.035a4 4 0 0 1-2.454 2.455c-.642.224-1.44.224-3.036.224s-2.393 0-3.035-.224a4 4 0 0 1-2.454-2.455c-.225-.641-.225-1.44-.225-3.035"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets_svg__o)",
    fillOpacity: 0.25,
    d: "M31.381 40.286c0-1.596 0-2.394.225-3.036a4 4 0 0 1 2.454-2.454c.642-.224 1.44-.224 3.035-.224s2.394 0 3.036.224a4 4 0 0 1 2.454 2.454c.225.642.225 1.44.225 3.036s0 2.394-.225 3.035a4 4 0 0 1-2.454 2.455c-.642.224-1.44.224-3.036.224s-2.393 0-3.035-.224a4 4 0 0 1-2.454-2.455c-.225-.641-.225-1.44-.225-3.035",
    style: {
      mixBlendMode: "screen"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    strokeWidth: 0.714,
    d: "M37.095 34.929c1.626 0 2.348.005 2.918.204a3.64 3.64 0 0 1 2.235 2.235c.2.57.204 1.292.204 2.917 0 1.626-.004 2.349-.204 2.918a3.64 3.64 0 0 1-2.235 2.236c-.57.2-1.292.204-2.918.204s-2.347-.005-2.917-.204a3.64 3.64 0 0 1-2.235-2.236c-.2-.57-.205-1.292-.205-2.918 0-1.625.005-2.347.205-2.917a3.64 3.64 0 0 1 2.235-2.235c.57-.2 1.291-.204 2.917-.204Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 26.562,
    height: 26.562,
    x: 0.957,
    y: 0.325
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#datasets_svg__p)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#datasets_svg__q)",
    shapeRendering: "crispEdges"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets_svg__r)",
    fillOpacity: 0.5,
    d: "M8.524 11.714c0-1.596 0-2.394.224-3.035a4 4 0 0 1 2.455-2.455C11.844 6 12.643 6 14.238 6s2.394 0 3.036.224a4 4 0 0 1 2.454 2.455c.224.641.224 1.44.224 3.035s0 2.394-.224 3.036a4 4 0 0 1-2.454 2.454c-.642.225-1.44.225-3.036.225s-2.394 0-3.035-.225a4 4 0 0 1-2.455-2.454c-.224-.642-.224-1.44-.224-3.036"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets_svg__s)",
    fillOpacity: 0.25,
    d: "M8.524 11.714c0-1.596 0-2.394.224-3.035a4 4 0 0 1 2.455-2.455C11.844 6 12.643 6 14.238 6s2.394 0 3.036.224a4 4 0 0 1 2.454 2.455c.224.641.224 1.44.224 3.035s0 2.394-.224 3.036a4 4 0 0 1-2.454 2.454c-.642.225-1.44.225-3.036.225s-2.394 0-3.035-.225a4 4 0 0 1-2.455-2.454c-.224-.642-.224-1.44-.224-3.036",
    style: {
      mixBlendMode: "screen"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    strokeWidth: 0.714,
    d: "M14.238 6.357c1.626 0 2.348.005 2.918.205a3.64 3.64 0 0 1 2.235 2.235c.2.57.204 1.291.204 2.917s-.005 2.348-.204 2.918a3.64 3.64 0 0 1-2.235 2.235c-.57.2-1.292.204-2.918.204s-2.347-.005-2.917-.204a3.64 3.64 0 0 1-2.236-2.235c-.199-.57-.204-1.292-.204-2.918s.005-2.347.204-2.917a3.64 3.64 0 0 1 2.236-2.235c.57-.2 1.291-.205 2.917-.205Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 26.562,
    height: 26.562,
    x: 0.957,
    y: 28.896
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(.95px)",
      clipPath: "url(#datasets_svg__t)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 1.892,
    filter: "url(#datasets_svg__u)",
    shapeRendering: "crispEdges"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets_svg__v)",
    fillOpacity: 0.2,
    d: "M8.524 40.286c0-1.596 0-2.394.224-3.036a4 4 0 0 1 2.455-2.454c.641-.224 1.44-.224 3.035-.224s2.394 0 3.036.224a4 4 0 0 1 2.454 2.454c.224.642.224 1.44.224 3.036s0 2.394-.224 3.035a4 4 0 0 1-2.454 2.455c-.642.224-1.44.224-3.036.224s-2.394 0-3.035-.224a4 4 0 0 1-2.455-2.455c-.224-.641-.224-1.44-.224-3.035"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datasets_svg__w)",
    d: "M8.524 40.286c0-1.596 0-2.394.224-3.036a4 4 0 0 1 2.455-2.454c.641-.224 1.44-.224 3.035-.224s2.394 0 3.036.224a4 4 0 0 1 2.454 2.454c.224.642.224 1.44.224 3.036s0 2.394-.224 3.035a4 4 0 0 1-2.454 2.455c-.642.224-1.44.224-3.036.224s-2.394 0-3.035-.224a4 4 0 0 1-2.455-2.455c-.224-.641-.224-1.44-.224-3.035",
    style: {
      mixBlendMode: "screen"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    strokeWidth: 0.714,
    d: "M14.238 34.929c1.626 0 2.348.005 2.918.204a3.64 3.64 0 0 1 2.235 2.235c.2.57.204 1.292.204 2.917 0 1.626-.005 2.349-.204 2.918a3.64 3.64 0 0 1-2.235 2.236c-.57.2-1.292.204-2.918.204s-2.347-.005-2.917-.204a3.64 3.64 0 0 1-2.236-2.236c-.199-.57-.204-1.292-.204-2.918 0-1.625.005-2.347.204-2.917a3.64 3.64 0 0 1 2.236-2.235c.57-.2 1.291-.204 2.917-.204Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "datasets_svg__a",
    width: 14.286,
    height: 15,
    x: 12.81,
    y: 11,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.089
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_4766"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.357
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4384_4766",
    result: "effect2_dropShadow_4384_4766"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4384_4766",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets_svg__b",
    width: 14.286,
    height: 15,
    x: 12.81,
    y: 27.428,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.089
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_4766"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.357
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4384_4766",
    result: "effect2_dropShadow_4384_4766"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4384_4766",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets_svg__c",
    width: 14.286,
    height: 15,
    x: 24.238,
    y: 11,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.089
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_4766"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.357
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4384_4766",
    result: "effect2_dropShadow_4384_4766"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4384_4766",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets_svg__d",
    width: 14.286,
    height: 15,
    x: 24.238,
    y: 27.428,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.089
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_4766"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.714
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.357
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4384_4766",
    result: "effect2_dropShadow_4384_4766"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4384_4766",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets_svg__f",
    width: 26.562,
    height: 26.562,
    x: 23.814,
    y: 0.325,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4766"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4766",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets_svg__j",
    width: 26.562,
    height: 26.562,
    x: 12.385,
    y: 14.61,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4766"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4766",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets_svg__m",
    width: 26.562,
    height: 26.562,
    x: 23.814,
    y: 28.896,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4766"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4766",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets_svg__q",
    width: 26.562,
    height: 26.562,
    x: 0.957,
    y: 0.325,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4766"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4766",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "datasets_svg__u",
    width: 26.562,
    height: 26.562,
    x: 0.957,
    y: 28.896,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.892
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.783
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4384_4766"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_4766",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "datasets_svg__g",
    x1: 37.095,
    x2: 37.095,
    y1: 11.071,
    y2: 17.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "datasets_svg__k",
    x1: 26.024,
    x2: 26.024,
    y1: 20.454,
    y2: 39.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "datasets_svg__n",
    x1: 37.095,
    x2: 37.095,
    y1: 39.643,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "datasets_svg__r",
    x1: 14.238,
    x2: 14.238,
    y1: 11.071,
    y2: 17.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "datasets_svg__v",
    x1: 14.238,
    x2: 14.238,
    y1: 39.643,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "datasets_svg__e",
    transform: "translate(-23.814 -.325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.381 11.714c0-1.596 0-2.394.225-3.035a4 4 0 0 1 2.454-2.455C34.702 6 35.5 6 37.095 6s2.394 0 3.036.224a4 4 0 0 1 2.454 2.455c.225.641.225 1.44.225 3.035s0 2.394-.225 3.036a4 4 0 0 1-2.454 2.454c-.642.225-1.44.225-3.036.225s-2.393 0-3.035-.225a4 4 0 0 1-2.454-2.454c-.225-.642-.225-1.44-.225-3.036"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "datasets_svg__i",
    transform: "translate(-12.385 -14.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.952 26c0-1.596 0-2.394.225-3.035a4 4 0 0 1 2.454-2.455c.642-.224 1.44-.224 3.036-.224s2.394 0 3.035.224a4 4 0 0 1 2.454 2.454c.225.642.225 1.44.225 3.036s0 2.394-.224 3.035a4 4 0 0 1-2.455 2.455c-.641.224-1.44.224-3.035.224s-2.394 0-3.036-.224a4 4 0 0 1-2.454-2.455c-.225-.641-.225-1.44-.225-3.035"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "datasets_svg__l",
    transform: "translate(-23.814 -28.896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.381 40.286c0-1.596 0-2.394.225-3.036a4 4 0 0 1 2.454-2.454c.642-.224 1.44-.224 3.035-.224s2.394 0 3.036.224a4 4 0 0 1 2.454 2.454c.225.642.225 1.44.225 3.036s0 2.394-.225 3.035a4 4 0 0 1-2.454 2.455c-.642.224-1.44.224-3.036.224s-2.393 0-3.035-.224a4 4 0 0 1-2.454-2.455c-.225-.641-.225-1.44-.225-3.035"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "datasets_svg__p",
    transform: "translate(-.957 -.325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.524 11.714c0-1.596 0-2.394.224-3.035a4 4 0 0 1 2.455-2.455C11.844 6 12.643 6 14.238 6s2.394 0 3.036.224a4 4 0 0 1 2.454 2.455c.224.641.224 1.44.224 3.035s0 2.394-.224 3.036a4 4 0 0 1-2.454 2.454c-.642.225-1.44.225-3.036.225s-2.394 0-3.035-.225a4 4 0 0 1-2.455-2.454c-.224-.642-.224-1.44-.224-3.036"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "datasets_svg__t",
    transform: "translate(-.957 -28.896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.524 40.286c0-1.596 0-2.394.224-3.036a4 4 0 0 1 2.455-2.454c.641-.224 1.44-.224 3.035-.224s2.394 0 3.036.224a4 4 0 0 1 2.454 2.454c.224.642.224 1.44.224 3.036s0 2.394-.224 3.035a4 4 0 0 1-2.454 2.455c-.642.224-1.44.224-3.036.224s-2.394 0-3.035-.224a4 4 0 0 1-2.455-2.455c-.224-.641-.224-1.44-.224-3.035"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "datasets_svg__h",
    width: 4,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#datasets_svg__x",
    transform: "scale(.0039)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "datasets_svg__o",
    width: 4,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#datasets_svg__x",
    transform: "scale(.0039)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "datasets_svg__s",
    width: 4,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#datasets_svg__x",
    transform: "scale(.0039)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "datasets_svg__w",
    width: 4,
    height: 4,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#datasets_svg__x",
    transform: "scale(.0039)"
  })))));
};
export default SvgDatasets;